/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GimbalOrientationMode {
}

export enum GimbalOrientationMode_Enum {
  LANDSCAPE = 0,
  LANDSCAPE_FLIPPED = 1,
  AUTO = 2,
  UNRECOGNIZED = -1,
}

export function gimbalOrientationMode_EnumFromJSON(object: any): GimbalOrientationMode_Enum {
  switch (object) {
    case 0:
    case "LANDSCAPE":
      return GimbalOrientationMode_Enum.LANDSCAPE;
    case 1:
    case "LANDSCAPE_FLIPPED":
      return GimbalOrientationMode_Enum.LANDSCAPE_FLIPPED;
    case 2:
    case "AUTO":
      return GimbalOrientationMode_Enum.AUTO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GimbalOrientationMode_Enum.UNRECOGNIZED;
  }
}

export function gimbalOrientationMode_EnumToJSON(object: GimbalOrientationMode_Enum): string {
  switch (object) {
    case GimbalOrientationMode_Enum.LANDSCAPE:
      return "LANDSCAPE";
    case GimbalOrientationMode_Enum.LANDSCAPE_FLIPPED:
      return "LANDSCAPE_FLIPPED";
    case GimbalOrientationMode_Enum.AUTO:
      return "AUTO";
    case GimbalOrientationMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseGimbalOrientationMode(): GimbalOrientationMode {
  return {};
}

export const GimbalOrientationMode = {
  encode(_: GimbalOrientationMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GimbalOrientationMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGimbalOrientationMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GimbalOrientationMode {
    return {};
  },

  toJSON(_: GimbalOrientationMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GimbalOrientationMode>, I>>(base?: I): GimbalOrientationMode {
    return GimbalOrientationMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GimbalOrientationMode>, I>>(_: I): GimbalOrientationMode {
    const message = createBaseGimbalOrientationMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
